<div
  class="fixed right-0 bottom-0 transition-transform"
  [ngClass]="{
    'translate-x-0': isPanelOpen$ | async,
    'translate-x-[376px]': (isPanelOpen$ | async) === false,
  }">
  @if (callPhase$ | async; as callPhase) {
    <button
      (click)="togglePanel()"
      class="shadow-small shadow-green-80 absolute bottom-[64px] left-0 flex h-12 w-[58px] translate-x-[-58px] cursor-pointer appearance-none items-center justify-center rounded-l-full pl-2 text-white transition-colors"
      [ngClass]="{
        'bg-green-80': callPhase === 'idle',
        'bg-amber-60':
          callPhase === 'ringing' || callPhase === 'wrapping-up' || callPhase === 'preparing',
        'bg-red-80': callPhase === 'on-call',
      }">
      <t-icon key="call" color="inherit" size="small" />
    </button>
  }

  <div class="h-screen w-[376px] bg-white" #aircallWorkspace></div>
</div>
